import { format, isValid } from 'date-fns'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { YYYYMMDDtoDate } from 'src/functions/format'
import { useAppSelector } from 'src/hooks/redux'
import { getWindevLang } from 'src/lib/lang'
import { RootState } from 'src/store'

type DetailsProps = {
    document: DocumentObject
}

const Details = ({document}:DetailsProps) => {
    const {t, i18n} = useTranslation()

    const colleagues:ForwardUser[] = useAppSelector((state:RootState)=>state.colleagues)
    const metatypes:MetatypeObject[] = useAppSelector((state:RootState) => state.metatypes)

    function usernameToName(name:string) {
        let n = name
        const user = Array.isArray(colleagues) ? colleagues.find(u=>u.username.toLowerCase() === name.toLowerCase()) : undefined
        if(user){
            n = `${user.firstname} ${user.name}`
        }
        return n
    }

  return (
    <div className="grid grid-cols-2 gap-2">
        <p className="font-semibold">Docid</p>
        <p>{document.docid}</p>

        <p className="font-semibold">{t('Versie')}</p>
        <p>{document.version}</p>

        <p className="font-semibold">{t('Gebruiker')}</p>
        <p>{usernameToName(document.user)}</p>

        <p className="font-semibold">{t('Bestandsnaam')}</p>
        <p>{document.filename}</p>

        <p className="font-semibold">{t('Document datum')}</p>
        <p>{document.docdate && isValid(YYYYMMDDtoDate(document.docdate)) && format(YYYYMMDDtoDate(document.docdate), "dd/MM/yyyy")}</p>

        {document.metadata.map((metadata, index) => {
            return (
                <React.Fragment key={index}>
                    <p className="font-semibold">{metatypes.find(m=>m.metatype===metadata.metatype)?.metatype_oms.find(o=>o.nationid===getWindevLang(i18n.language))?.oms}</p>
                    <p>{metadata.metavalue}</p>
                </React.Fragment>
            )
        })}
    </div>
  )
}

export default Details